import { makeStyles } from 'tss-react/mui'

export const useStyle = makeStyles<{
  backgroundImg?: string
  bgColor?: string
}>()((theme, { backgroundImg, bgColor }) => ({
  root: {
    display: 'flex',
  },
  image: {
    backgroundImage: backgroundImg ? `url("${backgroundImg}")` : undefined,
    backgroundRepeat: 'no-repeat',
    backgroundColor: theme.palette.grey[50],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    position: 'relative',
    zIndex: 0,
    minHeight: '70vh',
  },
  paper: {
    margin: theme.spacing('5vw', ' 1vw', '3vw', '2vw'),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  formDiv: {
    background: bgColor ? bgColor : theme.palette.opaque.main,
    zIndex: 3,
  },
  children: {
    minWidth: theme.spacing(85.625),
    ['@media (max-width:1127px)']: {
      minWidth: '45em',
    },
    overflow: 'hidden',
    boxShadow: theme.shadows[8],
  },
  cardChildrenContent: {
    flexGrow: 1,
    padding: theme.spacing(10, 10, '0', 10),
    '&.MuiCardContent-root:last-child': {
      paddingBottom: theme.spacing(10),
    },
  },
  divForm: {
    position: 'relative',
    overflow: 'hidden',
    maxWidth: '45.8em',
    right: '12vw',
    marginTop: theme.spacing(12.125),
    minHeight: '70vh',
    ['@media (max-width:960px)']: {
      maxWidth: '100%',
      right: '0',
      marginTop: theme.spacing(21.125),
    },
  },
  footer: {
    paddingBottom: theme.spacing(1.5),
    ['@media (max-width:960px)']: {
      marginBottom: theme.spacing(1.25),
      marginTop: theme.spacing(1.875),
    },
  },
  banner: {
    position: 'relative',
    width: '100%',
    boxShadow: theme.shadows[8],
  },
  logoImg: {
    maxWidth: theme.spacing(5.25),
    cursor: 'pointer',
    marginBottom: '0.1em',
    ['@media (max-width:960px)']: {
      maxWidth: theme.spacing(5.25),
    },
    display: 'block',
    marginLeft: theme.spacing(1.5),
  },
  cardContent: {
    height: theme.spacing(11.875),
    fontWeight: 400,
    borderRadius: 0,
    border: 'none',
    boxShadow: 'none',
    ['@media (max-width:960px)']: {
      paddingLeft: '60vw',
    },
  },
  labraTag: {
    color: theme.palette.black.dark,
    fontSize: '18px',
    fontWeight: 500,
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(1.5),
    textDecoration: 'none',
    all: 'unset',
    cursor: 'pointer',
  },
  tagText: {
    height: theme.spacing(11.875),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 'inherit',
    color: theme.palette.black.dark,
    fontSize: '14px',
  },
}))
